const titleMap = {
  enrolments: 'Enrolments',
  team: 'Team',
  student: 'Student',
  students: 'Participants',
  courses: 'Courses',
};

export function getProviderTitle(currentPage) {
  let title = titleMap[currentPage] || '';
  if (title) {
    title += ' • ';
  }

  return title;
}
